<script type="text/jsx">
import { mapGetters } from 'vuex';

import ParticipantsDiffPopover from '@/plans/LARGE_MEETING/component/participants-diff-popover.vue';
import planCommonMixin from '@/plans/WEBINAR/mixin';
import PlanDetailsMixin from '@/plans/EVENT_SAAS/component/dialog/plan-details/mx-plan-details';
import ConfigBase from '@/components/config-base';
import { toLowercaseString } from '@/common/utils';

export default {
  name: 'ConfigBase',
  extends: ConfigBase,
  mixins: [planCommonMixin, PlanDetailsMixin],
  components: { ParticipantsDiffPopover },
  data() {
    return {
      orderByKey: "capacity",
    };
  },
  props: {
    showPlanDetails: Boolean,
    planDetailsLabel: String,
  },
  computed: {
    ...mapGetters(['currentEditPlan']),
    maxCapacityDesc() {
      return toLowercaseString(this.orderSelectedPlansByDesc[0]?.capacityDesc) || this.$t('billing.event_services.unit.million_1_uppercase');
    },
    configDesc(){
      if (this.$context.is.switch) {
        return this.$t('billing.webinar.engage_your_audiences_desc');
      }
      return `${this.$t('billing.webinar.engage_your_audiences_desc')} ${this.$t('billing.webinar.up_to_x_attendees_y_panelists', [this.maxCapacityDesc,100])}`;
    }
  },
  methods: {
    mx_renderConfigDesc() {
      if (this.$context.is.modalDelta) return '';
      return this.$slots.configDesc ?
        this.$slots.configDesc :
        (<p class="opc-addon-config__main__title">
        <span>{this.configDesc}</span>
        <participants-diff-popover type={this.planType} />
      </p>);
    },
    mx_renderTitle() {
      const isShowCheckIcon = this.hasSelectedPlan;

      return <h2 ref='baseCardName' class={`opc-zm-base-card__name text-capitalize ${this.isExpanded ? 'title-pr__without-edit' : 'title-pr__with-edit'}`}>
        {
          this.$context.is.modalDelta ?
            `${this.title} | ${this.currentEditPlan?.capacity} ${this.$t('billing.participants')}` :
            this.title
        }
        {isShowCheckIcon ? <i check-icon class="zm-icon-success main-icon" aria-hidden="true" /> : null}
      </h2>;
    },
  },
};
</script>
